/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createAsyncThunk } from "@reduxjs/toolkit";
import isEmpty from "lodash/fp/isEmpty";

import ReportApi from "~/features/reportTracker/ReportApi";
import { ReportDeleteRequest } from "~/features/reportTracker/types";

export const loadReportsMetadataAsync = createAsyncThunk("report/loadReportsMetadata", async () => {
  const res = await ReportApi.getResellerReportsMetadata();
  const { result } = res.data;

  return !isEmpty(result) ? result : [];
});

export const deleteReportAsync = createAsyncThunk("report/deleteReport", async (payload: ReportDeleteRequest) => {
  const res = await ReportApi.deleteReport(payload);
  const { result } = res.data;

  return result;
});
